// PlanComponents/CardItem.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { bg, text as textColors, border, shadow } from '../../../utils/darkModeAdapter';

/**
 * CardItemコンポーネント
 * - タイトルとメインコンテンツを表示
 * - AIアドバイスを常時表示
 */
export default function CardItem({ title, children, adviceContent, titleExtra }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3 }}>
      {/* メインカード */}
      <Box
        sx={{
          p: 2.5,
          borderRadius: 3,
          backgroundColor: bg(theme).card,
          border: `1px solid ${border(theme).default}`,
          boxShadow: shadow(theme).card,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: shadow(theme).md,
            transform: 'translateY(-1px)',
          },
        }}
      >
        {/* タイトル部分 */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: '1.1rem',
              color: textColors(theme).primary,
              wordBreak: 'break-word',
            }}
          >
            {title}
          </Typography>
          {titleExtra}
        </Box>

        {/* メイン内容 */}
        <Box sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
          {children}
        </Box>
      </Box>

      {/* AIアドバイス（常時表示） */}
      {adviceContent && (
        <Box sx={{ mt: 2 }}>
          {adviceContent}
        </Box>
      )}
    </Box>
  );
}